module.exports = __webpack_public_path__ + "img/30.8.TSS.b7e4030a.png";